import React from 'react';
import { useLocation } from 'react-router-dom';
import { Navbar, Nav } from '@bphxd/ds-core-react';
import classes from './SubtrackerNavbar.module.scss';
import { useSelectedAsset } from '../../../lib/util';
import { isParentPath } from '../../../lib/util/router';

interface SubtrackerItem {
  label: string;
  link: string;
}

interface SubtrackerNavbarProps {
  subtrackerItems: SubtrackerItem[];
}

const SubtrackerNavbar: React.FC<SubtrackerNavbarProps> = ({ subtrackerItems }) => {
  const location = useLocation();
  const asset = useSelectedAsset();

  return (
    <Navbar
      className={`navbar-border navbar-secondary d-none d-lg-flex justify-content-center navbar-tabs ${classes.navbar}`}
      expand
      size="md"
      fixed="top"
    >
      <Nav navbar>
        {subtrackerItems.map(({ label, link }) => (
          <Nav.Link
            key={link}
            className={`${classes.navbarItem} ${isParentPath(link, location.pathname) ? classes.selectedItem : ''}`}
            href={`${link}?asset=${asset?.assetName}`}
            role="button"
          >
            {label}
          </Nav.Link>
        ))}
      </Nav>
    </Navbar>
  );
};

export default SubtrackerNavbar;
